import api from "../index";
import { apiUrl, constant } from "../../utils/constants";

export const GetScheduleDetails = (params) => api.get(`${constant.V1}${apiUrl.schedule_detail}/`, { params })
export const GetScheduleDetailsDates = (params) => api.get(`${constant.V1}${apiUrl.schedule_detail}/dates/`, { params })
